import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";
import tokenService from "../../Common/tokenDecoder";

export default {
    
    getAllOperationEntitiesForDropDown,
    getRoleFilteringData,
    saveRole,
    editData, 
    getAlllRoleLevels

};

async function saveRole(data) {
    console.log(data)
    let role = {            
        aspNetRoleId: 0,
        name: data.name.trim(),
        normalizedName: data.name.toUpperCase(),
        concurrencyStamp: '0',
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        roleLevel:parseInt(data.roleLevel),
        isActive: data.isActive,
        createdBy: parseInt(1),
        createdDate: new Date().toISOString(),
        modifiedBy: parseInt(0),
        modifiedDate: new Date().toISOString(),
    }
    
    const response = await CommonPost('/api/Role/SaveRole', null, role);
    return response;  
} 

async function editData(data) {
    data.name = data.name.trim();
    data.normalizedName = data.name.toUpperCase();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Role/UpdateRole', null, data);
    return response;
    console.log(data)
}

async function getRoleFilteringData(data) {
    var filtermodel = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        roleLevel:parseInt(tokenService.getRoleLevelFromToken())
    }
    const response = await CommonPost('/api/Role/FilterRoleByGroupEntityLevel', null, filtermodel);
    return response.data;
    
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getAlllRoleLevels() {
    var roleLevelArray = [];
    var level = parseInt(tokenService.getRoleLevelFromToken());
    var response = await CommonGet('/api/Role/GetAllRoleLevels', 'userRoleLevel=' + level);
    
    for (let item of Object.entries(response.data)) {
        roleLevelArray[item[1]["roleLevelID"]] = item[1]["roleLevelNo"];
    }
     return roleLevelArray;
}



